<template>
    <div class>
        <el-card class="box-card" shadow="hover">
            <div style="margin-bottom: 20px;">
                <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
            </div>
            <el-form
                :inline="true"
                :rules="rules"
                :model="agentForm"
                ref="agentForm"
                label-position="right"
                label-width="140px"
            >
                <!-- 基本信息 -->
                <template>
                    <div class="m-title">基本信息</div>
                    <el-form-item label="代理商昵称" prop="nickname">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="agentForm.nickname"
                            placeholder="请输入代理商昵称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="代理商手机号" prop="phone">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="agentForm.phone"
                            placeholder="请输入代理商手机号"
                            :maxlength="11"
                        ></el-input>
                    </el-form-item>
                    <br />
                </template>
                <template>
                    <div class="m-title">实名信息</div>
                    <div v-loading="imgLoading" element-loading-text="图片上传中,请稍等....">
                        <el-form-item label="法人身份证正面照" prop="id_card_positive">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleFrontIdCardImg"
                            >
                                <img
                                    v-if="agentForm.card_positive_img_path != ''"
                                    :src="agentForm.card_positive_img_path"
                                    class="avatar"
                                />
                                <img
                                    v-else
                                    :src="require('../../../assets/images/idcard_f3x.png')"
                                    class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="法人身份证反面照" prop="id_card_negative">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleBackIdCardImg"
                            >
                                <img
                                    v-if="agentForm.card_negative_img_path != ''"
                                    :src="agentForm.card_negative_img_path"
                                    class="avatar"
                                />
                                <img
                                    v-else
                                    :src="require('../../../assets/images/idcard_r3x.png')"
                                    class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                    </div>
                    <el-form-item label="法人姓名" prop="real_name">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="agentForm.real_name"
                            placeholder="请输入法人姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="证件号" prop="id_card">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="agentForm.id_card"
                            placeholder="请输入证件号"
                        ></el-input>
                    </el-form-item>
                    <br />
                    <el-form-item label="证件有效期" prop="card_valid_sdate">
                        <el-date-picker
                            v-model="cardRange"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            :disabled="isSelect"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            @change="handleCardChange"
                        ></el-date-picker>
                        <span style="margin-left:10px">
                            <el-checkbox
                                :true-label="1"
                                :false-label="0"
                                :disabled="agentForm.card_valid_sdate == ''"
                                @change="handleCheckboxChange"
                                v-model="agentForm.is_long_time"
                            >长期</el-checkbox>
                        </span>
                    </el-form-item>
					<br />
                </template>
                <!-- 结算信息 -->
                <template>
                    <div class="m-title">结算信息</div>
                    <div v-loading="imgLoading" element-loading-text="图片上传中,请稍等....">
                        <el-form-item label="银行卡照片">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleOpenAccountImg"
                            >
                                <img
                                    v-if="agentForm.opening_permit_img_path != ''"
                                    :src="agentForm.opening_permit_img_path"
                                    class="avatar"
                                />
                                <img
                                    v-else
                                    :src="require('../../../assets/images/other3x.png')"
                                    class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                    </div>
                    <el-form-item label="银行名称" prop="bank_id">
                        <el-select
                            size="medium"
                            v-model="agentForm.bank_id"
                            filterable
                            show-search
                            @change="handleBankChange"
                            placeholder="请选择银行名称"
                        >
                            <el-option
                                v-for="item in bankList"
                                :label="item.bank_name"
                                :value="item.id"
                                :key="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="银行归属地区" prop="bank_prov">
                        <el-cascader
                            separator="-"
                            filterable
                            :disabled="agentForm.bank_id == ''"
                            v-model="areaTempArr"
                            :options="areaList"
                            :props="cascaderProps"
                            placeholder="请选择银行归属地区"
                            @change="handleAreaChange"
                        ></el-cascader>
                        <!-- <div>{{agentForm.bank_prov}}{{agentForm.bank_city}}{{agentForm.bank_area}}</div> -->
                    </el-form-item>
                    <el-form-item label="结算支行名称" prop="branch_bank_id">
                        <el-select
                            size="medium"
                            v-model="agentForm.branch_bank_id"
                            filterable
                            :disabled="agentForm.bank_prov == ''"
                            @change="handleBranchChange"
                            placeholder="请选择结算支行名称"
                        >
                            <el-option
                                v-for="item in branchList"
                                :label="item.bank_branch"
                                :value="item.id"
                                :key="item.id"
                            ></el-option>
                        </el-select>
                        <!-- <div>{{agentForm.branch_bank}}</div> -->
                    </el-form-item>
                    <el-form-item label="联行号" prop="line_num">
                        <el-input
                            size="medium"
                            disabled
                            suffix-icon="el-icon-aux"
                            v-model="agentForm.line_num"
                            placeholder="请输入联行号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="法人银行卡号" prop="bank_code">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="agentForm.bank_code"
                            placeholder="请输入法人银行卡号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="银行卡预留手机"
                        prop="bank_phone"
                    >
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="agentForm.bank_phone"
                            placeholder="请输入银行卡预留手机"
                            :maxlength="11"
                        ></el-input>
                    </el-form-item>
                </template>
            </el-form>
            <div style="margin-top:20px">
                <el-button
                    type="primary"
                    :loading="loading"
                    style="font-size: 12px;"
                    @click="handleSubmit(agentForm)"
                >保存设置</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import areaList from '../../../utils/area';
import rules from './addAgentValid';
export default {
    data() {
        return {
            cardRange: [], // 身份证有效期
            uploadUrl: this.$api.uploadUrl, // 上传图片的地址
            loading: false, // 提交loading
            imgLoading: false, // 上传图片loading
            isSelect: false, // 根据是否选中长期来判断身份证截止日期是否可选
            bankList: [], // 银行列表
			regionList:[],
            bankSign: '', // 选中银行的标识
            branchList: [], // 银行支行列表
            areaList, // 省市区数据
            areaTempArr: [], // 省市区列表
            cascaderProps: { // 省市区指定属性
                value: 'areaName',
                label: 'areaName'
            },
            user_id:this.$route.query.user_id,
            agentForm: {
                nickname: '', 
                phone: '', 
                real_name: '', 
                id_card: '', 
                id_card_positive: '', 
                id_card_negative: '',
                card_valid_sdate: '', 
                card_valid_edate: '', 
                is_long_time: 0, // 是否长期
                card_positive_img_path: '', // 身份证正面--展示
                card_negative_img_path: '', // 身份证反面--展示
                
                bank_phone:'',
                bank_id: '', // 银行id
                branch_bank_id: '', // 分行id
                branch_bank: '', // 分行名
                account_type:2,
                line_num: '', // 联行号
                bank_code: '', // 银行卡号
                opening_permit_img: '', // 开户许可照片
                opening_permit_img_path: '', // 开户许可照片--展示
                bank_prov: '', // 开户省
                bank_city: '', // 开户市
                bank_area: '', // 开户区
            },
            rules: rules
        }
    },
    created() {
        
        this.getAgentMessage()
    },
    mounted() {
        
    },
    methods: {
        
        getAgentMessage() {
            this.$api.post("user_extend/findUserDetail", {user_id:this.$route.query.user_id}, res => {
                if (res.code == 0) {
                    this.agentForm = Object.assign(this.agentForm, res.data)
                    this.getBank(); //获取银行列表
                    this.areaTempArr = [res.data.bank_prov,res.data.bank_city,res.data.bank_area]
                    this.cardRange = []
                    if ('2099-12-31' == this.agentForm.card_valid_edate){
                        this.cardRange = [this.agentForm.card_valid_sdate, '2099-12-31'];
                    }else {
                        this.cardRange = [this.agentForm.card_valid_sdate, this.agentForm.card_valid_edate];
                    }
                    this.agentForm.card_positive_img_path = this.agentForm.id_card_positive_url
                    this.agentForm.card_negative_img_path = this.agentForm.id_card_negative_url
                }
            })
            
        },
        
        handleSubmit(agentForm) { //后台提交
            this.$refs.agentForm.validate(valid => {
                if (valid) {
                    this.loading = true; //防重复
                    this.$api.post('user_extend/saveUserDetail', agentForm, res => {
                        let that = this;
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: res.msg,
                                duration: 1500,
                                onClose() {
                                    that.loading = false;
                                    that.$router.back();
                                }
                            });
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.msg,
                                duration: 1500,
                                onClose() {
                                    that.loading = false;
                                }
                            });
                        }
                    })
                }
            })
        },
        
        handleAreaChange(areaArr) { // 处理银行归属地区数据
            if (areaArr.length != 0) {
                this.agentForm.bank_prov = areaArr[0];
                this.agentForm.bank_city = areaArr[1];
                this.agentForm.bank_area = areaArr[2];
                if (this.agentForm.bank_id) {
                    this.agentForm.branch_bank_id = '';
                    this.agentForm.line_num = '';
                    this.getBranch();
                }
            } else {
                this.agentForm.bank_prov = '';
                this.agentForm.bank_city = '';
                this.agentForm.bank_area = '';
            }
        },
        handleCheckboxChange(value) { // 处理是否长期
            if (value == 1) {
                this.isSelect = true;
                if (this.cardRange.length) { // 已选择有效期后进行修改
                    this.cardRange = [this.cardRange[0], '2099-12-31'];
                    this.agentForm.card_valid_edate = '2099-12-31';
                }
            } else {
                this.isSelect = false;
                if (this.cardRange.length) {
                    this.cardRange = [this.cardRange[0], this.$moment(Date.now()).format('YYYY-MM-DD')];
                    this.agentForm.card_valid_edate = '';
                }
            }
        },
        
        handleBankChange(bankVal) { // 处理银行选中时获取值
            if (bankVal) {
                let bank = this.bankList.filter(item => {
                    return item.id == bankVal;
                });
                this.bankSign = bank[0].bank_symbol;
                if (this.agentForm.bank_prov) { //银行和省不为空的情况选择银行可取支行
                    this.agentForm.branch_bank_id = '';
                    this.agentForm.line_num = '';
                    this.getBranch();
                }
            } else {
                this.areaTempArr = []; // 清空银行时将归属地清空
                this.agentForm.bank_prov = '';
                this.agentForm.bank_city = '';
                this.agentForm.bank_area = '';
            }
        },
        handleBranchChange(branchVal) { // 支行选中的处理
            if (branchVal) {
                let branchLineNum = this.branchList.filter(item => {
                    return item.id == branchVal;
                });
                this.agentForm.line_num = branchLineNum[0].line_num; // 联行号
                this.agentForm.branch_bank = branchLineNum[0].bank_branch; // 支行名称
            }
        },
        handleImgLoading() { // 上传文件时加载loading
            this.imgLoading = true;
        },
        handleOpenAccountImg(res) { // 银行卡号
            this.upImg({
                res,
                path: 'opening_permit_img',
                img: 'opening_permit_img_path'
            });
        },
        handleFrontIdCardImg(res) { // 身份证正面
            this.upImg({
                res,
                path: 'id_card_positive',
                img: 'card_positive_img_path'
            });
        },
        handleBackIdCardImg(res) { // 身份证反面
            this.upImg({
                res,
                path: 'id_card_negative',
                img: 'card_negative_img_path'
            });
        },
        getBranch() { // 获取支行
            this.$api.post('common_func/bankHfBranch', { bank_symbol: this.bankSign, bank_prov: this.agentForm.bank_prov, bank_city: this.agentForm.bank_city,limit:10000 }, res => {
                if (res.code == 0) {
                    
                    this.branchList = [];
                    this.branchList = res.data;
                } else {
                    this.$message.error('获取支行信息失败，请重新选择银行或归属地进行获取!');
                }
            });
        },

        getBank() { // 获取银行列表
            this.$api.post("common_func/getBank", {}, res => {
                if (res.code == 0) {
                    this.bankList = res.data;
                    let bank = this.bankList.filter(item => {
                        return item.id == this.agentForm.bank_id;
                    });
                    this.bankSign = bank[0].bank_symbol;
                    this.getBranch();
                }
            })
        },
        upImg(res) { //公用
            let resData = res.res;
            if (resData.code === 0) {
                this.agentForm[res.img] = resData.data.file_url; //展示路径
                this.agentForm[res.path] = resData.data.file_path //请求路径
                let type = 1
                if (res.path == 'id_card_positive'){
                    type = 1
                }
                if (res.path == 'id_card_negative'){
                    type = 2
                }
                if (res.path == 'opening_permit_img'){
                    type = 4
                }
                this.getOCR(resData.data.file_path,type)
            } else {
                //错误提示
                this.$message.error(res.msg);
            }
            this.imgLoading = false;
        },
        getOCR(image,type) { // OCR
            this.$api.post("common_func/ocrImage", {image:image,type}, res => {
                if (res.code == 0) {
                    let obj = res.data
                    if (type == 1){
                        this.agentForm.real_name = obj.name
                        this.agentForm.id_card = obj.number
                    }
                    if (type == 2){
                        this.agentForm.card_valid_sdate = obj.start_date
                        this.agentForm.card_valid_edate = obj.end_date
                        this.cardRange = []
                        if ('2099-12-31' == this.agentForm.card_valid_edate){
                            this.cardRange = [this.agentForm.card_valid_sdate, '2099-12-31'];
                        }else {
                            this.cardRange = [this.agentForm.card_valid_sdate, this.agentForm.card_valid_edate];
                        }
                    }
                    if (type == 4){
                        this.agentForm.bank_code = obj.card_number
                    }
                    
                }
            })
        },
        handleCardChange(dateArr) { // 身份证有效期处理
            if (dateArr) {
                this.agentForm.card_valid_sdate = dateArr[0];
                this.agentForm.card_valid_edate = dateArr[1];
            }
        }
    }
}
</script>

<style scoped lang="scss">
.el-form-item {
    margin-bottom: 22px;
}
.m-title {
    color: #303133;
    font-size: 14px;
    font-weight: 700;
    padding-left: 10px;
    margin: 10px 0;
    border-left: 4px solid #409eff;
}
.line {
    text-align: center;
}
::v-deep .el-input-group__append {
    color: #ffffff;
    font-size: 12px;
    background-color: #409eff;
}
.el-form-item__content .el-input-group {
    vertical-align: middle;
}
.avatar-uploader {
    width: 200px;
    height: 130px;
    border-radius: 10px;
    overflow: hidden;
}
::v-deep .avatar-uploader .el-upload {
    width: 100%;
    height: 100%;
}
.avatar {
    width: 100%;
    height: 100%;
}
</style>
